import React, {FC, useEffect, useState} from "react";
import {apiUrlWithStore} from "../../helper";
import {useRouter} from "next/router";
import {CheckToastSvg} from "../../svg";
import {CustomTextArea, CustomTextField} from "../../atoms";
import {useToast} from "../../atoms/Toast/useToast";
import {useSelector} from "react-redux";
import {IState} from "../../types/state";
import {TranslationsType} from "../../types/homePageTypes";
import PageHeader from "../shared/PageHeader";
import {useReCaptcha} from "next-recaptcha-v3";

interface IProps {
    translationsData: TranslationsType;
    breadcrumb: Array<{ title: string; url: string }>;
    recaptchaActive: string
}
type formValuesType = {
    email: string;
    full_name: string;
    phone: string;
    message: string;
    re_token?: string
}

const ContactWithUs: FC<IProps> = (
    {
        translationsData,
        breadcrumb,
        recaptchaActive
    }
) => {
    const toast = useToast();
    const initialValues = {email: "", full_name: "", phone: "", message: ""};
    const [formValues, setFormValues]
        = useState<Omit<formValuesType, "re_token">>(initialValues);
    const [isSubmitting, _] = useState<boolean>(false);
    const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});
    const {executeRecaptcha} = useReCaptcha();

    const history = useRouter();
    const submitForm = async () => {
        setFormErrors(validate(formValues));
        let body = formValues as formValuesType
        if (String(recaptchaActive) === "1") {
            const token = await executeRecaptcha("form_submit");
            body = {
                ...formValues,
                re_token: token
            }
        }
        let options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        };

        fetch(apiUrlWithStore(`/api/contact-us-send`), options)
            .then((response) => response.json())
            .then((res) => {
                if (res.success === true) {
                    // FIXME warning
                    history.push("/")

                    //@ts-ignore
                    toast.open(
                        <span className="d-flex chek-fms">
                            <CheckToastSvg/>
                            {translationsData.MessageSentSuccessfully}
                        </span>
                    );
                }
            })
            .catch((err) => console.error(err));
    };
    const handleChange = (e: any) => {
        setFormValues({...formValues, [e.target.name]: e.target.value});
    };
    // const handleSubmit = (e: { preventDefault: () => void; }) => {
    //     e.preventDefault();
    //     setFormErrors(validate(formValues));
    //     setIsSubmitting(true);
    // };
    const validate = (values: {
        email: string;
        full_name?: string;
        phone?: string;
        message: string;
        name?: string;
    }) => {
        let errors: { [key: string]: string } = {
            name: '',
            email: '',
            message: ''
        };
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        // const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

        if (!values.full_name) {
            errors.name = "the_first_name_field_is_required";
        }

        if (!values.email) {
            errors.email = "the_email_field_is_required";
        }

        if (values.email && !regex.test(values.email)) {
            errors.invalidEmail = "invalid_email_format";
        }


        if (!values.message) {
            errors.message = "this_field_is_required";
        }

        if (!values.phone) {
            errors.phone = "the_phone_field_is_required.";
        }
        return errors;
    };

    useEffect(() => {
        if (Object.keys(formErrors).length === 0 && isSubmitting) {
            (async () => await submitForm())();
        }
    }, [formErrors]);

    return (
        <>
            <PageHeader header="" breadcrumb={breadcrumb}/>
            <div className="container contact-with-us">
                <h1 className="contact-customhtml-fms">
                    {translationsData.ContactWithUs}
                </h1>
                <div className="fieldset-params-fms">
                    <div className="contact_field">
                        <CustomTextField
                            withStar={true}
                            type="email"
                            value={translationsData.Email}
                            className="contact-with-input"
                            handleChange={handleChange}
                            name="email"
                            inpValue={formValues.email}
                        />
                        {
                            formErrors?.email ? (
                                <div className="alert-danger">
                                    {translationsData.TheEmailFieldIsRequired}
                                </div>
                            ) : formErrors?.invalidEmail ? (
                                <div className="alert-danger">
                                    {translationsData.InvalidEmailFormat}
                                </div>
                            ) : ""
                        }
                    </div>

                    <div className="contact_field">
                        <CustomTextField
                            className="contact-with-input"
                            value={translationsData.FirstName}
                            withStar={true}
                            handleChange={handleChange}
                            name="full_name"
                            inpValue={formValues.full_name}
                        />

                        {
                            formErrors?.name && (
                                <div className="alert-danger">
                                    {translationsData.ThisFieldIsRequired}
                                </div>
                            )
                        }
                    </div>

                    <div className="contact_field">
                        <CustomTextField
                            type="number"
                            value={translationsData.Phone}
                            className="contact-with-input"
                            withStar={true}
                            handleChange={handleChange}
                            name="phone"
                            inpValue={formValues.phone}
                        />

                        {
                            formErrors?.phone && (
                                <div className="alert-danger">
                                    {translationsData.ThePhoneFieldIsRequired}
                                </div>
                            )
                        }
                    </div>
                </div>

                <div className="comment required">
                    <div>
                        <CustomTextArea
                            id="outlined-message-input_5"
                            className="comment-field"
                            label="Comment message"
                            inpValue={formValues.message}
                            value={translationsData.Comment}
                            withStar={true}
                            type="text"
                            handleChange={handleChange}
                            name="message"
                        />
                        {
                            formErrors?.message && (
                                <div className="alert-danger">
                                    {translationsData.ThisFieldIsRequired}
                                </div>
                            )
                        }
                    </div>
                </div>

                <div className="action-fms">
                    <button
                        onClick={submitForm}
                        className="btn btn-orange inner-addToCart rounde-pills btn-lg"
                    >
                        <span>
                            {translationsData.Send}
                        </span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default ContactWithUs